import { HistoryOutlined, LockOutlined, MailOutlined } from "@ant-design/icons";
import { t, Trans } from "@lingui/macro";
import { Col, Form, Input } from "antd";
import React from "react";

export default function ModalContent({form, user, focusInputRef}) {
    const titleDOM = (
        <>
            <Col className="modal-icon-col flex-center" span={24}>
                <HistoryOutlined />
            </Col>
            <Col className="modal-text-col flex-center" span={24}>
                <h2><Trans>You&#39;ve been idle for more than 2 hours.</Trans></h2>
                <Trans>Validate to resume your session.</Trans>
            </Col>
        </>
    );
    return (
        <>
            {titleDOM}
            <Col className="modal-form-col flex-center" span={24}>
                <Form
                    form={form}
                    // onKeyDown={e => {
                    //     if (e.key === "Enter")
                    //         handleOk();
                    // }}
                >
                    <Form.Item
                        name="email"
                        initialValue={user.email}
                    >
                        <Input
                            prefix={<MailOutlined />}
                            disabled
                        />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{
                            required: true,
                            message: t`Password is required to validate`,
                        }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder={t`Password`}
                            allowClear
                            // autofocus issue: https://github.com/ant-design/ant-design/issues/8668
                            ref={focusInputRef}
                            autoFocus
                        />
                    </Form.Item>
                </Form>
            </Col>
        </>
    );
}
